import ApiExecutor from "./executor";

/**
 * Single axios-backed executor shared by all BizForm API clients (auth interceptors apply once).
 */
export const bizFormSharedApiExecutor = new ApiExecutor();
